export default __webpack_public_path__ + "static/media/share-blue.2dd25f59.svg";